"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class PlatformStatusController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            status: '/v1/admin/index/status',
            stats: '/v1/admin/stats',
            reindex: '/v1/admin/index/:entityName/reindex',
            trigger: '/v1/admin/check/:entityName/trigger',
            dedup: '/v1/admin/check/:entityName/dedup/trigger',
            global: '/v1/admin/check/:entityName/global/trigger',
            cancel: '/v1/admin/check/cancel',
            rebuild: '/v1/admin/index/:indexName/rebuild',
            monitor: '/v1/monitor/disk',
        };
    }
    status() {
        return this.manager.get({ url: this.endpoints.status });
    }
    stats() {
        return this.manager.get({ url: this.endpoints.stats });
    }
    reindex(entityName) {
        return this.manager.post({ url: this.endpoints.reindex, params: { entityName } });
    }
    trigger(entityName) {
        return this.manager.get({ url: this.endpoints.trigger, params: { entityName } });
    }
    rebuild(indexName) {
        return this.manager.post({ url: this.endpoints.rebuild, params: { indexName } });
    }
    dedup(entityName) {
        return this.manager.post({ url: this.endpoints.dedup, params: { entityName } });
    }
    global(entityName) {
        return this.manager.post({ url: this.endpoints.global, params: { entityName } });
    }
    cancel() {
        return this.manager.post({ url: this.endpoints.cancel });
    }
    monitor() {
        return this.manager.get({ url: this.endpoints.monitor });
    }
}
exports.default = PlatformStatusController;
